<template>
  <div class="cta-bubles">
    <div class="cta-bubles__content">
      <div class="cta-bubles__title">
        {{ $t('blog.ctaBublesTitleLine1', lang) }} <br />
        {{ $t('blog.ctaBublesTitleLine2', lang) }}
      </div>
      <router-link
        :to="$t('routes.signup', lang)"
        class="button button--accent"
        :alt="$t('header.createYourList', lang)"
        @click="browse"
        >{{ $t('blog.startYourList', lang) }}</router-link
      >
      <!-- /signup -->
    </div>
    <div class="cta-bubles__cover">
      <img src="../../assets/img/covers/cover-cta-icons.svg" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "CtaPost",
  computed: {
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
  methods: {
    browse() {
      this.$router.push({
        name: "BlogCategory",
        params: { slug: "listas-de-ejemplo" },
      });
    },
  },
};
</script>
